export const galleryEvent = {
    afterAppendSlide: 'cres:gallery:afterAppendSlide',
    init: 'cres:gallery:init',
    hasVideo: 'cres:gallery:hasVideo',
    containerResize: 'cres:gallery:containerResize',
    updateSlides: 'cres:gallery:updateSlides',
    afterAppendSubHtml: 'cres:gallery:afterAppendSubHtml',
    beforeOpen: 'cres:gallery:beforeOpen',
    afterOpen: 'cres:gallery:afterOpen',
    slideItemLoad: 'cres:gallery:slideItemLoad',
    beforeSlide: 'cres:gallery:beforeSlide',
    afterSlide: 'cres:gallery:afterSlide',
    posterClick: 'cres:gallery:posterClick',
    dragStart: 'cres:gallery:dragStart',
    dragMove: 'cres:gallery:dragMove',
    dragEnd: 'cres:gallery:dragEnd',
    beforeNextSlide: 'cres:gallery:beforeNextSlide',
    beforePrevSlide: 'cres:gallery:beforePrevSlide',
    beforeClose: 'cres:gallery:beforeClose',
    afterClose: 'cres:gallery:afterClose',
    rotateLeft: 'cres:gallery:rotateLeft',
    rotateRight: 'cres:gallery:rotateRight',
    flipHorizontal: 'cres:gallery:flipHorizontal',
    flipVertical: 'cres:gallery:flipVertical',
    autoplay: 'cres:gallery:autoplay',
    autoplayStart: 'cres:gallery:autoplayStart',
    autoplayStop: 'cres:gallery:autoplayStop'
};
